export default __webpack_public_path__ + "static/media/info_gray.37acf9a1.svg";